<div>
  <!-- <app-header></app-header> -->
  <router-outlet></router-outlet>
  <!-- <app-footer></app-footer> -->
</div>
<!-- <ngx-spinner type="ball-scale-multiple"></ngx-spinner> -->
<!-- <ngx-spinner type="square-jelly-box" size="medium"></ngx-spinner> -->
<ngx-spinner
  [fullScreen]="true"
  type="ball-clip-rotate-multiple"
  size="medium"
></ngx-spinner>
<!-- <ngx-spinner [fullScreen]="true"  type="ball-fussion"  size="medium"></ngx-spinner> -->
<!-- <ngx-spinner [fullScreen]="true"  type="ball-spin-clockwise"  size="medium"></ngx-spinner> -->
<!-- <ngx-spinner [fullScreen]="true" type="cog" size="medium"></ngx-spinner> -->
<!-- <ngx-spinner [fullScreen]="true" type="timer" size="medium"></ngx-spinner> -->
